import React, { useEffect, useState } from "react";
import './view.css'
import { Button, Form, Input, message, Modal, notification, Space, } from "antd";
import { useLocation, useParams } from "react-router-dom";
import { dropdownService, invoiceService } from "../../../services";
import { ROLES } from "../../../constants";
import MakePayment from "./MakePayment";
import EditModal from "./EditModal";
import { checkPermission } from "../../../utils/permissions";
import { changeDocumentTitle } from "../../../utils/title";

export const ViewInvoice = () => {
  const location = useLocation();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [charges, setCharges] = useState([]);
  const [disable, setDisable] = useState(true);
  const [paymentmodes, setPaymentModes] = useState([]);
  const [banks, setBanks] = useState([]);
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [invoice, setInvoice] = useState([]);
  const [isModalshow, setIsModalShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [total, setTotal] = useState(null)
  const role = localStorage.getItem("role");


  const columns = [
    {
      title: "Chasis#",
      dataIndex: "chasis_no",
      key: "chasis_no",
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          readOnly
        />
      ),
    },
    {
      title: "Freight",
      dataIndex: "freight_charges",
      key: "freight_charges",
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) => handleInputChange(e, index, "freight_charges")}
        />
      ),
    },
    {
      title: "Towing",
      dataIndex: "towing_charges",
      key: "towing_charges",
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) => handleInputChange(e, index, "towing_charges")}
        />
      ),
    },
    {
      title: "Yard",
      dataIndex: "yard_charges",
      key: "yard_charges",
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) => handleInputChange(e, index, "yard_charges")}
        />
      ),
    },
    {
      title: "loading",
      dataIndex: "loading_charges",
      key: "loading_charges",
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) => handleInputChange(e, index, "loading_charges")}
        />
      ),
    },
    {
      title: "chasis",
      dataIndex: "chasis",
      key: "chasis",
      render: (text, record, index) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) => handleInputChange(e, index, "chasis")}
        />
      ),
    },
    {
      title: "Total Amount",
      dataIndex: "invoice_amount",
      key: "invoice_amount",
    },
  ];


  const visibleModal = () => setIsModalVisible(true);

  const showModal = () => {
    setIsModalShow(true);
  };

  const handleCancel = () => {
    setIsModalShow(false);
    // setIsModalOpen(false);
    setIsModalVisible(false);
  };

  const handleInputChange = (e, index, field) => {
    const value = e.target.value;
    invoice.invoice.vehicles[index][field] = value;
  };


  const handleApprove = async () => {
    setLoading(true)
    const response = await invoiceService.approveInvoice(invoice?.invoice?.id);
    setLoading(false)
    if (response.success) {
      message.info(`${response.data.emailSended}`)
      // notification.success({
      //   message: "Invoice Approved!",
      //   description: response.message,
      //   placement: "topRight",
      // });
    }
    initialize();
    setIsModalShow(false);
  };


  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  const onFinish = async (values) => {
    const data = {
      discount: values.discount,
      extraCharge: values?.charges?.length > 0 ? values?.charges?.map((item) => item.first) : null,
      extraChargeAmount: values?.charges?.length > 0 ? values?.charges?.map((item) => item.last) : null,
      freight_charges: invoice?.invoice?.vehicles?.reduce((acc, item) => {
        acc[item.id] = item.freight_charges;
        return acc;
      }, {}),
      towing_charges: invoice?.invoice?.vehicles?.reduce((acc, item) => {
        acc[item.id] = item.towing_charges;
        return acc;
      }, {}),
      yard_charges: invoice?.invoice?.vehicles?.reduce((acc, item) => {
        acc[item.id] = item.yard_charges;
        return acc;
      }, {}),
      loading_charges: invoice?.invoice?.vehicles?.reduce((acc, item) => {
        acc[item.id] = item.loading_charges;
        return acc;
      }, {}),
      chasis_charges: invoice?.invoice?.vehicles?.reduce((acc, item) => {
        acc[item.id] = item.chasis;
        return acc;
      }, {}),
      invoice_amount: invoice?.invoice?.vehicles?.reduce((acc, item) => {
        acc[item.id] = item.invoice_amount;
        return acc;
      }, {}),
    };
    setLoading(true)
    const response = await invoiceService.updateInvoice(
      invoice.invoice.id,
      data
    );
    setLoading(false)
    if (response.success) {
      notification.success({
        message: "Invoice updated successfully!",
        description: response.message,
        placement: "topRight",
      });
    }
    initialize();
    setIsModalVisible(false);
  };

  const handlePayment = async (values) => {
    const data = {
      ...values,
      payment_date: values.payment_date.format("YYYY-MM-DD"),
      payment_mode_name: paymentmodes.find(
        (mode) => mode.id === values.payment_mode
      )?.name,
    };
    const response = await invoiceService.makePayment(data);
    if (response.success) {
      notification.success({
        message: "Payment Made Successfully!",
        description: response.message,
        placement: "topRight",
      });
    }
    form2.resetFields();
    initialize();
    // setIsModalOpen(false);
  };


  const getPaymentModes = async () => {
    const response = await dropdownService.fetchPaymentModes();
    if (response.success) {
      setPaymentModes(response.data);
    }
  };

  // const getBanks = async () => {
  //   const response = await dropdownService.fetchBanks();
  //   if (response.success) {
  //     setBanks(response.data);
  //   }
  // };
  // const getInvoices = async () => {
  //   const response = await dropdownService.fetchInvoices();
  //   if (response.success) {
  //     const filteredInvoices = response.data.filter(
  //       (item) => item.is_partial !== 2
  //     );
  //     setPendingInvoices(filteredInvoices);
  //   }
  // };


  const handlePrint = () => {
    const divToPrint = document.getElementById("printableDiv");
    if (!divToPrint) return;

    const originalContent = document.body.innerHTML; // Store the original content
    const printContent = divToPrint.innerHTML;

    // Create a new style tag to center the content
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `

        body {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          height: auto;
          margin: 5;
          padding: 5;
        }
        #printableDiv {
          width: 100%;
          max-width: 800px; /* Adjust based on your preference */
          padding: 20px;
          box-sizing: border-box;
          text-align: center; /* Optional: centers text within the div */
          }

        @page {
          size: auto;
        }

        `;

    // Temporarily add the style to the head section
    document.head.appendChild(styleTag);

    // Replace body content with the div content
    document.body.innerHTML = printContent;

    // Open print dialog
    window.print();

    // Restore original content and remove the dynamically added style
    document.body.innerHTML = originalContent;
    document.head.removeChild(styleTag);

    // Reload the page to fix any broken scripts
    // window.location.reload();
  };

  const initialize = async () => {
    if (role === ROLES.CUSTOMER) {
      const { success, data } = await invoiceService.viewCustomerInvoice(id);
      if (success) {
        setInvoice(data);
        form.setFieldsValue({
          discount: data?.invoice?.discount,
        });
      }
    } else {
      const { success, data } = await invoiceService.viewInvoice(id);
      if (success) {
        const response = await invoiceService.getInvoiceCharges(id);
        if (response.success) {
          // setCharges(response.data.extras)
          form.setFieldsValue({
            charges: response.data.extras.map((extra) => ({
              first: extra.extra_charge,
              last: extra.extra_charge_amount,
            }))
          });
        }
        setInvoice(data);
        setTotal(parseFloat(data.subTotal) - parseFloat(data.invoice.discount) - Math.abs(parseFloat(data.credit_amount)));
        form.setFieldsValue({
          discount: data?.invoice?.discount,
        });
        form2.setFieldsValue({
          amount: data.invoice.total,
        });
        if (data?.invoice?.total === 0) {
          // setDisable(true);
          form2.setFieldsValue({
            status: 0,
          });
        }
      }
    }
  };

  useEffect(() => {
    changeDocumentTitle("Invoice View");
    initialize();
    getPaymentModes();
    // getBanks();
    // getInvoices();
  }, [])

  useEffect(() => {
    if (location.search.includes("download=true") && invoice?.id) {
      handlePrint();
    }
  }, [location, invoice]);


  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        id="printableDiv"
        style={{
          padding: "15px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#FFFFFF",
          // backgroundColor: "red",
          width: "850px",
        }}
      >
        <div className="main">
          {/* /////top start//////// */}
          <div className="top">
            <div>
              <img
                src="/images/ctrade-logo.png"
                alt=""
                style={{ width: "100px", height: "55px" }}
              />
              <h3>CTRADE USA INC</h3>
            </div>
            <div style={{ fontSize: "15px", lineHeight: 1.2, textAlign: "right" }}>
              3902 SWINGLE RD
              <br />
              HOUSTON TX 77047
              <br />
              UNITED STATES
              <br />
              Mobile: +1 832-819-2622 <br />
              Email: trade@ctrade.us
            </div>
          </div>
          <h1 className="invoice-heading">INVOICE Number: {invoice?.invoice?.id}</h1>
          {/* /////top end//////// */}
          <div className="seperatorTwo"></div>
          {/* /////second start//////// */}
          <div className="second">
            <h4 style={{ fontWeight: "lighter" }}>
              Bill-to Party:   {invoice?.customer?.name}
            </h4>
            <div>
              <h4 style={{ fontWeight: "lighter" }}>
                Invoice Date:   {invoice?.invoice?.date}
              </h4>
              <h4 style={{ fontWeight: "lighter" }}>
                Invoice Due:   {invoice?.invoice?.due_date}
              </h4>
              <h4 style={{ fontWeight: "lighter" }}>
                Payment terms:   Payable immediately
              </h4>
            </div>
          </div>
          {/* /////second end//////// */}
          <h3
            className="subHeading"
            style={{ fontSize: "18px" }}
          >
            <span style={{ fontWeight: "bold" }}>BOOKING Number:</span> {invoice?.invoice?.vehicles[0]?.booking_no}
          </h3>
          <div className="seperatorTwo"></div>
          {/* /////third start//////// */}
          <div className="third">
            <div style={{ marginLeft: "10px" }}>
              <h4 style={{ fontWeight: "lighter" }}>POL: HOUSTON  </h4>
              <h4 style={{ fontWeight: "lighter" }}>POD:   </h4>
              <h4 style={{ fontWeight: "lighter" }}>
                Product Id: Ctrade U.S.A
              </h4>
            </div>
            <div style={{ marginLeft: "3vw" }}>
              <h4 style={{ fontWeight: "lighter" }}>
                Place of Receipt: Houston
              </h4>
              <h4 style={{ fontWeight: "lighter" }}> Place of Delivery:  </h4>
            </div>
          </div>
          {/* /////third end//////// */}
          <div className="seperator"></div>
          <h2 className="subHeading" style={{ marginTop: "10px" }}>
            TOTAL AMOUNT DUE
          </h2>
          {/* /////fourth start//////// */}
          <table style={{ width: "100%" }}>
            <tr
              className="table"
              style={{
                border: "2px solid #B83D3D",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>Condition</td>
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>Rate</td>
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>BaseValue</td>
              <td style={{ fontWeight: "bold", fontSize: "14px" }}>
                Total (USD)
              </td>
            </tr>
            <tr
              className="table"
              style={{
                paddingLeft: "1vw",
                paddingRight: "1vw",
              }}
            >
              <td style={{ fontSize: "14px" }}>Net Value </td>
              <td></td>
              <td></td>
              <td style={{ fontSize: "14px" }}> {invoice?.invoice?.total}.00</td>
            </tr>
            <tr
              className="table"
              style={{
                paddingLeft: "1vw",
                paddingRight: "1vw",
              }}
            >
              <td style={{ fontSize: "14px" }}>Discount</td>
              <td></td>
              <td></td>
              <td style={{ fontSize: "14px" }}>
                {invoice?.invoice?.discount}.00
              </td>
            </tr>
            {invoice?.credit_amount ? <tr
              className="table"
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <td style={{ fontSize: "14px" }}>Credit Amount</td>
              <td></td>
              <td></td>
              <td style={{ fontSize: "14px" }}>
                {invoice?.credit_amount}.00
              </td>
            </tr> : <></>}
            <tr
              className="table"
              style={{
                border: "2px solid #B83D3D",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <td style={{ fontWeight: "bold", fontSize: "16px" }}>Amount Due</td>
              <td></td>
              <td></td>
              <td style={{ fontWeight: "bold" }}></td>
              <td style={{ fontWeight: "bold", fontSize: "16px" }}>
                ${total?.toLocaleString() || "0.00"}
              </td>
            </tr>
          </table>

          <div className="vehicle-details" style={{ width: "805px" }}>
            {invoice?.invoice?.vehicles?.length > 0 && <table >
              <thead>
                <tr
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    width: "802px",
                  }}
                >
                  <th
                    style={{
                      width: "170px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Vehicle
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Receiving Date
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Loading Date
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    Days
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Storage
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Freight Loading
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Towing
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "start",
                    }}
                  >
                    Chassis
                  </th>
                  <th
                    style={{
                      width: "90px",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {invoice?.invoice?.vehicles?.map((vehicle, index) => {
                  let frieghtLoading = parseFloat(vehicle?.freight_charges) + parseFloat(vehicle?.loading_charges);
                  let amount = parseFloat(vehicle?.yard_charges) + frieghtLoading + parseFloat(vehicle?.towing_charges) + parseFloat(vehicle?.chasis);
                  return (
                    <>
                      <tr
                        // key={index}
                        style={{
                          justifyContent: "space-between",
                          display: "flex",
                          width: "802px",
                          borderBottom: "2px solid #b83d3d"
                        }}
                      >
                        <td
                          style={{
                            width: "170px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          <div>
                            {vehicle?.year} {vehicle?.vehicle}
                          </div>
                          <div
                            style={{
                              marginTop: "4px",
                              fontSize: "11px",
                              color: "#666",
                            }}
                          >
                            {vehicle?.chasis_no}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          {vehicle.date_rcd.slice(0, 10)}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          {invoice?.invoice?.pull_out_date}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {vehicle.days}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${vehicle?.yard_charges?.toLocaleString() || "0.00"}
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${frieghtLoading}.00
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${vehicle?.towing_charges}.00
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "start",
                          }}
                        >
                          ${vehicle?.chasis}.00
                        </td>
                        <td
                          style={{
                            width: "90px",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          ${amount.toLocaleString() || "0.00"}
                        </td>
                      </tr>
                    </>
                  )
                })}
              </tbody>
              {invoice?.extras?.length > 0 &&
                <>
                  <thead style={{ borderTop: "1px solid #B83D3D" }}>
                    <tr style={{ display: 'flex', justifyContent: "space-between", borderBottom: "1px solid #B83D3D" }}>
                      <th>Extra Charges</th>
                      <th style={{ paddingRight: 5 }}>Total (USD)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice?.extras?.map((extra, index) => (
                      <>
                        <tr style={{ display: "flex", justifyContent: "space-between", paddingRight: 5 }}>
                          <td>
                            ${extra.extra_charge}
                          </td>
                          <td>
                            ${extra.extra_charge_amount}
                          </td>
                        </tr>
                      </>

                    ))}
                  </tbody>
                </>
              }
            </table>}
            {(invoice?.invoice?.vehicles?.length == 0 && invoice.extras.length > 0) && (
              <section className="extras-details">
                <table>
                  <thead >
                    <tr>
                      <th>
                        Description
                      </th>
                      <th>
                        Total (USD)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice?.extras?.map((extra, index) => (
                      <>
                        <tr key={index}
                          style={{
                            // ?display: "flex",
                            // justifyContent: "space-between",
                            fontSize: "20px",
                            // width: "798px",
                          }}>
                          <td>
                            ${extra.extra_charge}
                          </td>
                          <td>
                            ${extra.extra_charge_amount}
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>

              </section>
            )}
          </div>
          {/* /////seven end//////// */}
          {/* <div className="seperator" style={{ marginTop: "1vh" }}></div> */}
          <div className="break-div" style={{ width: "805px" }} >
            <div
              className="break-div"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <div style={{ border: "2px solid #b83d3d", width: '100%', display: 'flex', justifyContent: "end" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100px auto", // Two columns: 150px for headings, auto for values
                    gap: "5px 0px", // Row and column spacing
                    alignItems: "center",
                    fontSize: "12px",
                    textAlign: "left",
                    // backgroundColor: 'red',
                    // justifyContent: "end",
                    padding: 5,
                    marginRight: '28px'
                  }}
                >
                  <div style={{ fontWeight: "bold" }}>SubTotal:</div>
                  <div>
                    ${invoice?.invoice?.sub_total?.toLocaleString() || "0.00"}
                  </div>

                  <div style={{ fontWeight: "bold" }}>Discount:</div>
                  <div>
                    ${invoice?.invoice?.discount?.toLocaleString() || "0.00"}
                  </div>
                  {invoice?.credit_amount ?
                    <>
                      <div style={{ fontWeight: "bold" }}>Credit Amount:</div>
                      <div>
                        ${invoice?.credit_amount?.toLocaleString() || "0.00"}
                      </div>
                    </> : <></>
                  }

                  <div style={{ fontWeight: "bold" }}>Total:</div>
                  <div>${total?.toLocaleString() || "0.00"}</div>
                </div>
              </div>
            </div>
            {/* <div className="seperator" style={{ marginTop: "1vh" }}></div> */}
            {/* /////eight start//////// */}
            {invoice?.invoice?.vehicles.length > 0 && <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  width: "400px",
                  marginLeft: "3vw",
                }}
              >
                <div
                  style={{
                    width: "400px",

                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h5 style={{ width: "160px" }}>No </h5>
                  <h5 style={{ width: "260px" }}>Container Number</h5>
                  <h5 style={{ width: "120px" }}>Size</h5>
                </div>
                <div
                  style={{
                    width: "400px",

                    display: "flex",
                    justifyContent: "space-between",
                    borderTop: "1px solid #666",
                  }}
                >
                  <h5 style={{ fontWeight: "lighter", width: "160px" }}>1</h5>
                  <h5 style={{ fontWeight: "lighter", width: "260px" }}>
                    {invoice?.invoice?.vehicles[0]?.container_no}
                  </h5>
                  <h5 style={{ width: "120px", fontWeight: "lighter" }}>
                    {invoice?.invoice?.vehicles[0]?.container_size}
                  </h5>
                </div>
              </div>
            </div>}
            <div>
              <h5 style={{ fontSize: "15px", fontWeight: "bold", paddingLeft: 5 }}>{invoice?.invoice?.description}</h5>
            </div>
          </div>
          {/* /////eight end//////// */}
          <div className="seperator" style={{ marginTop: "3vh" }}></div>
          <div className="acc-info">
            <div className="top top2">
              <div>
                <img
                  src="/images/ctrade-logo.png"
                  alt=""
                  style={{ width: "100px", height: "55px" }}
                />
                <h3>CTRADE USA INC</h3>
              </div>
              <div style={{ fontSize: "14px" }}>
                3902 SWINGLE RD
                <br />
                HOUSTON TX 77047
                <br />
                UNITED STATES
                <br />
                Mobile: +1 832-819-2622 <br />
                Email: trade@ctrade.us
              </div>
            </div>
            <div className="top2 seperatorTwo"></div>
            <h5
              style={{
                marginLeft: "0vw",
                marginBottom: "20px",
                fontWeight: "bolder",
                marginTop: "20px",
              }}
            >
              Account Information
            </h5>
            {/* /////nine start//////// */}
            <div
              style={{
                display: "flex",
                marginLeft: "0vw",
                height: "3vh",
              }}
            >
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Account Name
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : CTRADE USA INC </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Bank Name
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : BANK OF AMERICA </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Account Number
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : 4881 2067 0589</h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Routing Number
              </h5>
              <h5 style={{ fontWeight: "lighter" }}>
                : 111000023/111000025 (PAPER & ELECTRONICS){" "}
              </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Routing Number
              </h5>
              <h5 style={{ fontWeight: "lighter" }}>
                : 026009593 ( WIRE TRANSFER - DOMESTIC ){" "}
              </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Swift Code
              </h5>
              <h5 style={{ fontWeight: "lighter" }}> : (US DOLLAR) BOFAUS3N </h5>
            </div>
            <div style={{ display: "flex", marginLeft: "0vw", height: "3vh" }}>
              <h5
                style={{
                  fontWeight: "lighter",
                  width: "15vw",
                }}
              >
                Branch Address
              </h5>
              <h5 style={{ fontWeight: "lighter" }}>
                : BANK OF AMERICA, N.A, 222 BROADWAY, NEWYORK, NY 10038
              </h5>
            </div>
            {/* /////nine end//////// */}
            <h5
              style={{
                fontWeight: "lighter",
                marginTop: "6vh",
                marginLeft: "0vw",
                marginRight: "0vw",
                color: "#53575A",
              }}
            >
              We do not accept CARD payments, only cashier's cheques or direct
              bank transfers.Any additional charges Government charges if any are
              applied will be charged at actual Payment should fall into the
              CTrade USA Inc account within 10 days after loading the container.
              <br />
              Any dispute in invoice should be raised within 07 days from the
              issue date otherwise it will be considered as confirmed.
              <br />
              <br /> Any invoice delayed from the due date will be subject to $100
              as late fees15 Day free at facilities there after $15 Day/Car from
              the day of receiving in and out charges will be $100 subject to
              storage charges.
            </h5>
            <h5
              style={{
                marginLeft: "0vw",
                marginRight: "0vw",
                fontWeight: "bolder",
              }}
            >
              Note*: Payment against this invoice will be accepted as terms and
              conditions confirmed. In case of delay in payment ctrade usa will
              not be responsbile for any storage demarruages/detentions
            </h5>
            <div
              className="seperatorTwo"
              style={{
                marginTop: "3vh",
                height: "1px",
                backgroundColor: "#8F9CA6",
              }}
            ></div>
            <h5
              style={{
                textAlign: "center",
                color: "#8F9CA6",
                fontWeight: "lighter",
                marginTop: "12px",
              }}
            >
              THANK YOU FOR DOING BUSINESS WIITH C TRADE USA INC.
            </h5>
          </div>
        </div>
      </div>
      <div
        style={{
          marginTop: "20px",
          marginBottom: "25px",
          display: "flex",
          justifyContent: "flex-end",
          width: "850px",
        }}
      >
        <Space>
          <Button type="primary" onClick={handlePrint}>
            <img src="/images/print.png" alt="" /> Print
          </Button>
          {invoice?.invoice?.status === 0 &&
            <>
              <Button type="primary" onClick={visibleModal}>
                <img src="/images/edit.png" alt="" /> Edit
              </Button>
              {checkPermission("APPROVE_INVOICE") && <Button type="primary" onClick={showModal}>
                Approve
              </Button>}
            </>
          }
          {/* <Button type="primary" onClick={openModal}>
            Make Payment
          </Button> */}
        </Space>
      </div>

      {/* Edit Modal */}

      <EditModal
        isModalVisible={isModalVisible}
        // handleOk={handleOk}
        handleCancel={handleCancel}
        invoice={invoice}
        loading={loading}
        columns={columns}
        onFinish={onFinish}
        form={form}
        vehicles={invoice?.invoice?.vehicles?.length}
      />

      {/* Make Payment Modal 
      {/*<MakePayment
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        form2={form2}
        handlePayment={handlePayment}
        pendingInvoices={pendingInvoices}
        paymentmodes={paymentmodes}
        banks={banks}
        invoice={invoice}
        disable={disable}
        setDisable={setDisable}
      />*/}

      {/* Approve Modal */}

      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleApprove}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "10px",
          },
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleApprove}
              loading={loading}
            // style={{ width: "30%" }}
            >
              Yes do it
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          You sure you want to approve this invoice and send to customer?
        </p>
      </Modal>
    </div>
  );
};

export default ViewInvoice;